import { NumberTileComponent } from '@diekeure/components';
import { MountTarget, newDialog } from './utils/elements';
import { registerHydrator } from './rehydrate';
NumberTileComponent;

export const GETALBEELD_EDIT_SELECTOR = '.cds-lrn-getalbeeld';

interface GetalbeeldConfig {
  tenFields: string;
}

registerHydrator(GETALBEELD_EDIT_SELECTOR, (cfg: GetalbeeldConfig) => {
  const el = document.createElement('dk-number-tile');
  el.setAttribute('allowedActions', '[]');
  if (cfg.tenFields) el.setAttribute('tenFields', cfg.tenFields);
  return el;
});

export function getalbeeldDialog(
  insertHtml: (html: string) => void,
  mountTarget?: MountTarget,
  existingEl?: HTMLElement
) {
  const dialog = newDialog('Getalbeeld maken', () => insertHtml(''), mountTarget);

  const tool = document.createElement('dk-number-tile');
  tool.setAttribute('authoring', '');

  let config: GetalbeeldConfig = { tenFields: '[]' };
  if (existingEl) {
    config = readExistingConfig(existingEl);
  }
  tool.setAttribute('tenFields', config.tenFields);

  tool.addEventListener('number-tile-changed', (event: CustomEvent) => {
    config = { tenFields: escapeSingleQuotes(event.detail.tenFields) };
  });

  dialog.querySelector('#cds-dialog-content').append(tool);

  dialog.addEventListener('onSubmit', () => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('cds-lrn-getalbeeld');
    wrapper.setAttribute('data-cb-config', JSON.stringify(config));
    insertHtml(wrapper.outerHTML);
  });
}

function readExistingConfig(el: HTMLElement): GetalbeeldConfig {
  try {
    return JSON.parse(el.getAttribute('data-cb-config') || '{"tenFields":"[]"}');
  } catch {
    return { tenFields: '[]' };
  }
}

function escapeSingleQuotes(str: string | object): string {
  if (!str) return '';
  if (typeof str !== 'string') str = JSON.stringify(str);

  return (str as string).replace(/'/g, '&#39;');
}
